import {Component, Input, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatOption} from '@angular/material/core';
import {MatDialog} from '@angular/material/dialog';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {MatSelect, MatSelectTrigger} from '@angular/material/select';
import {ClientService, Invitation} from '@app/admin/client.service';
import {InvitationLinkComponent} from '@app/invitation/invitation-link/invitation-link.component';
import {InvitationService} from '@app/invitation/invitation.service';
import {StringDialogComponent} from '@app/shared/string-dialog/string-dialog.component';
import {ROLES} from '@app/shared/user.service';
import {filter} from 'rxjs/operators';

@Component({
    selector: 'frog-invites',
    templateUrl: './invites.component.html',
    styleUrls: ['./invites.component.scss'],
    imports: [
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatSelect,
        MatSelectTrigger,
        MatOption,
        MatIconButton,
        MatIcon,
        MatButton,
        InvitationLinkComponent,
    ],
})
export class InvitesComponent implements OnInit {
    @Input() clientId: string;
    @Input() withLink: boolean;

    public form: FormGroup;
    public roles = ROLES;

    constructor(
        private clientService: ClientService,
        private invitationService: InvitationService,
        private matDialog: MatDialog,
        private formBuilder: FormBuilder,
    ) {
        this.form = this.formBuilder.group({
            invitations: this.formBuilder.array([]),
        });
        this.addInviteRow();
    }

    ngOnInit(): void {}

    get invitations() {
        return this.form.controls['invitations'] as FormArray;
    }

    addInviteRow(): FormGroup {
        const inviteForm = this.formBuilder.group({
            email: ['', Validators.email],
            role: 0,
        });
        this.invitations.push(inviteForm);

        return inviteForm;
    }

    removeRow(index: number) {
        this.invitations.removeAt(index);
    }

    getInvitations(): Invitation[] {
        return this.invitations.controls
            .map((control) => {
                const invitation = new Invitation();
                invitation.email = control.value.email;
                invitation.role = control.value.role;
                return invitation;
            })
            .filter((invitation) => Boolean(invitation.email.trim()));
    }

    addMultiple() {
        const data = {
            title: 'Add Invites',
            message: 'Enter email addresses separated by comma or new lines',
            multiline: true,
        };

        this.matDialog
            .open(StringDialogComponent, { data })
            .afterClosed()
            .pipe(filter((result) => result !== null))
            .subscribe((result: string) => {
                const lines = result
                    .replaceAll(',', '\n')
                    .split('\n')
                    .map((line) => line.trim());
                for (const line of lines) {
                    const form = this.addInviteRow();
                    form.setValue({
                        email: line,
                        role: 0,
                    });
                }

                this.invitations.markAllAsTouched();
            });
    }
}
